"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _QuantityPicker = require("@commerce-ui/core2/QuantityPicker");
var _Image = _interopRequireDefault(require("../Image"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _useCartModifier2 = _interopRequireDefault(require("@deosite/api/hooks/REST/useCartModifier"));
var _useOptionPicker2 = _interopRequireDefault(require("@deosite/api/hooks/REST/useOptionPicker"));
var _usePriceWithCurrency = _interopRequireDefault(require("@deosite/api/hooks/common/usePriceWithCurrency"));
var _useCategoryTree2 = require("@deosite/api/hooks/common/useCategoryTree");
var _useAnalytics4AndCommerceTags = _interopRequireDefault(require("@deosite/api/hooks/common/useAnalytics4AndCommerceTags"));
var _getLowProductAvailability = _interopRequireDefault(require("@deosite/helpers/getLowProductAvailability"));
var _Product = _interopRequireDefault(require("@deosite/ui-entities/Product"));
var __jsx = _react["default"].createElement;
var defaultProps = {
  showOptionsSelector: false,
  addToCartDisabled: false
};
var MinifiedProductPanel = function MinifiedProductPanel(props) {
  var _useOptionPicker = (0, _useOptionPicker2["default"])(props.product),
    product = _useOptionPicker.product,
    options = _useOptionPicker.options,
    selectedValues = _useOptionPicker.selectedValues;
  var priceWithCurrency = (0, _usePriceWithCurrency["default"])();
  var optionsSelector = props.optionsSelector,
    qtyPicker = props.qtyPicker,
    toCartButton = props.toCartButton,
    promoLabel = props.promoLabel,
    _props$showOptionsSel = props.showOptionsSelector,
    showOptionsSelector = _props$showOptionsSel === void 0 ? defaultProps.showOptionsSelector : _props$showOptionsSel,
    _props$addToCartDisab = props.addToCartDisabled,
    addToCartDisabled = _props$addToCartDisab === void 0 ? defaultProps.addToCartDisabled : _props$addToCartDisab;
  var outOfStock = (0, _getLowProductAvailability["default"])(product.availability.level);
  var price = product.price,
    image = product.image,
    name = product.name,
    sku = product.sku,
    selectedOptions = product.selectedOptions;
  var translations = {
    viewDetails: (0, _langLibrary["default"])("View details"),
    addToCart: (0, _langLibrary["default"])("Add to cart"),
    outOfStock: (0, _langLibrary["default"])("Out of stock"),
    brexit: (0, _langLibrary["default"])("Brexit"),
    productCode: (0, _langLibrary["default"])("product code")
  };
  var optionsSelector$ = /*#__PURE__*/_react["default"].cloneElement(optionsSelector, {
    options: options,
    selectedValues: selectedValues,
    minifiedVersion: true
  });
  var quantityPicker = (0, _QuantityPicker.useQuantityPicker)({
    maxValue: global.__appConfig__.quantityPickerMaxValue
  });
  var _useCartModifier = (0, _useCartModifier2["default"])({
      product: product,
      onSuccess: function onSuccess() {
        quantityPicker.reset();
      }
    }),
    loading = _useCartModifier.loading,
    add = _useCartModifier.add;
  var addToCartButton = /*#__PURE__*/_react["default"].cloneElement(toCartButton, {
    isLoading: loading,
    onClick: function onClick() {
      if (!loading && !outOfStock) {
        add(quantityPicker.amount);
      }
    },
    disabled: outOfStock
  }, translations.addToCart);
  var quantityPickerComponent = /*#__PURE__*/_react["default"].cloneElement(qtyPicker, {
    controller: quantityPicker
  });
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var _useAnalyticsAndComme = (0, _useAnalytics4AndCommerceTags["default"])(),
    productClicked = _useAnalyticsAndComme.productClicked;
  var _useCategoryTree = (0, _useCategoryTree2.useCategoryTree)(),
    getCategoryNameForGivenCategoryId = _useCategoryTree.getCategoryNameForGivenCategoryId;
  var brexit = __jsx(_Box["default"], {
    sx: {
      color: "main",
      font: "xs"
    }
  }, translations.brexit);
  return __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      mb: "s7"
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: [160, null, null, 240],
      position: "relative",
      zIndex: "1"
    }
  }, __jsx(Link, {
    route: "product-page",
    params: product
  }, __jsx(_LinkRaw["default"], {
    title: name,
    onClick: function onClick() {
      return productClicked(product, getCategoryNameForGivenCategoryId(product.category.id));
    }
  }, __jsx(_Image["default"], {
    overlay: true,
    sx: {
      aspectRatio: 1,
      objectFit: "contain",
      width: "100%"
    },
    image: image,
    sizes: "(max-width: 1410px) and (min-width: 10px) 210px, 420px",
    cloudflareEnabled: global.__appConfig__.smallImageCloudflareEnabled,
    quality: global.__appConfig__.smallImageQuality
  }))), promoLabel && __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      zIndex: "2",
      top: "8px",
      right: "9px"
    }
  }, promoLabel)), __jsx(_Box["default"], {
    sx: {
      width: ["calc(100% - 160px)", null, null, "calc(100% - 320px)"],
      display: "flex",
      flexDirection: "column",
      px: 24
    }
  }, __jsx(_Box["default"], {
    sx: {
      color: "neutral700",
      font: "xs_underline",
      mb: "s1",
      textDecoration: "none"
    }
  }, translations.productCode, " ", sku), outOfStock && __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: "body2",
      color: "neutral900"
    }
  }, translations.outOfStock), __jsx(_Box["default"], {
    sx: {
      color: outOfStock ? "neutral700" : "main",
      font: "body2",
      mb: "s3"
    }
  }, name), __jsx(_Box["default"], {
    sx: {
      color: "neutral700",
      textTransform: "capitalize",
      font: "xs",
      mb: "s3"
    }
  }, selectedOptions && Object.keys(selectedOptions)[0], " ", selectedOptions && Object.values(selectedOptions)[0]), price.special ? __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column"
    }
  }, __jsx(_Box["default"], {
    sx: {
      font: "base_sans_regular_discount",
      color: outOfStock ? "neutral700" : "main"
    }
  }, priceWithCurrency(price.regular)), __jsx(_Box["default"], {
    sx: {
      font: "base_sans_bold",
      color: outOfStock ? "neutral700" : "negative"
    }
  }, priceWithCurrency(price.special))) : __jsx(_Box["default"], {
    sx: {
      color: outOfStock ? "neutral700" : "main",
      font: "base_sans_bold"
    }
  }, priceWithCurrency(price.regular)), __jsx(_Box["default"], {
    sx: {
      color: "neutral700",
      font: "xs_underline"
    }
  }, __jsx(Link, {
    route: "product-page",
    params: product
  }, __jsx(_LinkRaw["default"], {
    title: name,
    onClick: function onClick() {
      return productClicked(product, getCategoryNameForGivenCategoryId(product.category.id));
    }
  }, translations.viewDetails)))), __jsx(_Box["default"], {
    sx: {
      width: 158,
      display: showOptionsSelector ? "none" : ["none", null, null, "flex"],
      flexDirection: ["row", null, null, "column"]
    }
  }, addToCartDisabled ? brexit : __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], null, quantityPickerComponent), __jsx(_Box["default"], {
    sx: {
      mt: "s6",
      width: "100%",
      minWidth: "100%"
    }
  }, addToCartButton)))), showOptionsSelector && __jsx(_Box["default"], null, optionsSelector$), __jsx(_Box["default"], {
    sx: {
      display: showOptionsSelector ? "flex" : ["flex", null, null, "none"],
      flexDirection: "row",
      justifyContent: "space-between"
    }
  }, addToCartDisabled ? brexit : __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
    sx: {
      width: ["160px", null, null, "233px"]
    }
  }, quantityPickerComponent), __jsx(_Box["default"], null, addToCartButton))));
};
var _default = MinifiedProductPanel;
exports["default"] = _default;